/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VisitType = {
    DropOffPickUp: 'Drop off/Pick up',
    ConditionReport: 'Condition Report',
    PhotographyVideography: 'Photography/Videography',
    PropertyCheck: 'Property Check',
    KeyBoxInstallation: 'Key Box Installation',
    StandardQc: 'Standard QC',
    LightweightQc: 'Lightweight QC',
    OccupiedPrewalk: 'Occupied Prewalk',
    Other: 'Other'
} as const;
export type VisitType = typeof VisitType[keyof typeof VisitType];


export function VisitTypeFromJSON(json: any): VisitType {
    return VisitTypeFromJSONTyped(json, false);
}

export function VisitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitType {
    return json as VisitType;
}

export function VisitTypeToJSON(value?: VisitType | null): any {
    return value as any;
}

